import { render, staticRenderFns } from "./recordForm.vue?vue&type=template&id=268af330&scoped=true&"
import script from "./recordForm.vue?vue&type=script&lang=js&"
export * from "./recordForm.vue?vue&type=script&lang=js&"
import style0 from "./recordForm.vue?vue&type=style&index=0&id=268af330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268af330",
  null
  
)

export default component.exports